import React, { SyntheticEvent } from "react";
import { Form } from 'react-bootstrap'
import { IAppState } from "../../state/interfaces";
import QuoteStepBase from '../../components/QuoteStepBase'
import ButtonContinue from "../../components/ButtonContinue";
import { IQuoteStepState, IQuoteStepComponentProps } from "../../components/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { connect } from "react-redux";
import { FULL_QUOTE_STEPS } from "../../AppConstants";
import { IAgreement, IESignatureForm } from "../../classes/ExternalQuote";
import ComplexCheckbox from "../../components/ComplexCheckbox";
import { IContactInfo, IQuoteApiClient, ILOBApiClient, IPaths } from "../../classes/Domain";
import ValidatableFormGroup from "../../components/ValidatableFormGroup";
import { validationUtils } from "../../validation/Validation";
import { ValidatableForm } from "../../components/ValidatableForm";
import { Checkbox } from "react-input-checkbox";
import { allFieldsValidation as contactInfoValidation } from "../../validation/fullQuote/ContactInfoValidation";
import QuoteActions from "../../state/appActions";
import FullQuoteActions from "../../state/fullQuoteActions";
import Utilities from "../../classes/Utilities";


export interface IEsignatureResponseData {
    esignatureForms: Array<IESignatureForm>
}

export interface IEsignatureResponse {
    data: IEsignatureResponseData
}

interface IAppStateUpdate {
    rtrQuoteId: number,
    agreement: IAgreement,
    contactInfo: IContactInfo,
    policyEffDate: string,
    effectiveDatetimeStamp: string
}

interface IProps extends IQuoteStepComponentProps {
    rtrQuoteId: number,
    contactInfo: IContactInfo,
    umCoverageDeclined: boolean,
    hasCompColl: boolean,
    policyEffDate: string,
    effectiveDatetimeStamp: string,
    resetAgreement: () => Promise<any>,
    quoteApiClient: IQuoteApiClient,
    lobApiClient: ILOBApiClient,
    PATHS: IPaths;
}

interface IState extends IQuoteStepState {
    agreeDrivers: boolean,
    //agreeVehicles: boolean,
    agreeEmailCorrect: boolean,
    contactInfo: IContactInfo;
    agreeOtherDrivers: boolean,
    //agreeSalvage: boolean,
    agreeUMDecline: boolean
    agreePolicyEffDate: boolean;
}

class Finalize extends QuoteStepBase<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.next = this.next.bind(this);
        this.validateContactInfo = this.validateContactInfo.bind(this);

        this.state = {
            agreeDrivers: true,
            //agreeVehicles: false,
            agreeOtherDrivers: false,
            //agreeSalvage: false,
            agreeUMDecline: true,
            updatingStore: false,
            agreeEmailCorrect: false,
            agreePolicyEffDate: false,
            contactInfo: this.props.contactInfo,
            errors: null
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
        this.props.resetAgreement();

        this.setState({ ...this.state, updatingStore: false, errors: null });

        validationUtils.subscribeToValidationFailure(FULL_QUOTE_STEPS.FINALIZE,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, errors: validationData });
            });
    }

    next(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        this.setState({ updatingStore: true }, () => {
            this.props.updateAppState({
                rtrQuoteId: this.props.rtrQuoteId,
                agreement: {
                    agreeDrivers: this.state.agreeDrivers,
                    agreeOtherDrivers: this.state.agreeOtherDrivers,
                    agreeUMDecline: this.state.agreeUMDecline,
                    agreeEmailCorrect: this.state.agreeEmailCorrect,
                    agreePolicyEffDate: this.state.agreePolicyEffDate
                },
                contactInfo: this.state.contactInfo
                //agreeSalvage: this.state.agreeSalvage
            })
                .then((esigResponse: IEsignatureResponse) => {
                    this.setState({ updatingStore: false }, () => {
                        if (esigResponse.data.esignatureForms && 0 < esigResponse.data.esignatureForms.length) {
                            this.props.history.push(Utilities.formatUrl(this.props.PATHS.FQ_ESIGNATURE, ""));
                        }
                        else {
                            this.props.history.push(this.props.PATHS.FQ_PAYMENT);
                        }
                    });
            },
            () => {
                this.setState({ ...this.state, updatingStore: false });
            });
        });
    }

    handleAgreeChange(event: SyntheticEvent, property: string) {
        var val = this.state[property];
        val = !val;
        this.setStateValue(val, property);
    }

    handleEmailChange(value: any) {
        this.setState({ contactInfo: { ...this.state.contactInfo, email: value } }, () => this.setState({ ...this.state, errors: null }));
    }

    validateContactInfo() {
        const { isValid, errors } = contactInfoValidation(this.state.contactInfo);

        if (!isValid) {
            validationUtils.publishValidationFailure(errors);
        }
    }


    render() {
        return (
            <QuoteStep id="finalize" className="policy-details">
                <div className="titleArea">
                    <h5>Signatures</h5>
                </div>

                <p className="info">Please review the statements for your policy</p>

                {
                    this.props.hasCompColl
                        ?
                        <ComplexCheckbox
                            children={
                                <div>
                                    <Form.Check.Label>I Agree</Form.Check.Label>
                                    <p>This is a named driver only policy and only the drivers listed in the application will be covered for physical damage coverage. (Comprehensive & Collision)</p>
                                </div>
                            }
                            value={this.state.agreeDrivers}
                            onChange={(e) => this.handleAgreeChange(e, "agreeDrivers")} />
                        :
                        null
                }

                {/*<ComplexCheckbox*/}
                {/*    children={*/}
                {/*        <div>*/}
                {/*            <Form.Check.Label>I Agree</Form.Check.Label>*/}
                {/*            <p>There are no vehicles registered to this applicant which are not listed on this application</p>*/}
                {/*        </div>*/}
                {/*    }*/}
                {/*    value={this.state.agreeVehicles}*/}
                {/*    onChange={(e) => this.handleAgreeChange(e, "agreeVehicles")} />*/}

                <ComplexCheckbox
                    children={
                        <div>
                            <Form.Check.Label>I Agree</Form.Check.Label>
                            <p>There are no other drivers living in the household not listed on this application</p>
                        </div>
                    }
                    value={this.state.agreeOtherDrivers}
                    onChange={(e) => this.handleAgreeChange(e, "agreeOtherDrivers")} />

                <ComplexCheckbox
                    children={
                        <div>
                            <Form.Check.Label>I Agree</Form.Check.Label>
                            <p>The policy effective date is: <strong>{this.props.policyEffDate + " as of " + this.props.effectiveDatetimeStamp}</strong></p>
                        </div>
                    }
                    value={this.state.agreePolicyEffDate}
                    onChange={(e) => this.handleAgreeChange(e, "agreePolicyEffDate")} />

                {/*{*/}
                {/*    <ComplexCheckbox*/}
                {/*        children={*/}
                {/*            <div>*/}
                {/*                <Form.Check.Label>I Agree</Form.Check.Label>*/}
                {/*                <p>No vehicles on this application have ever been salvaged or declared a total loss</p>*/}
                {/*            </div>*/}
                {/*        }*/}
                {/*        value={this.state.agreeSalvage}*/}
                {/*        onChange={(e) => this.handleAgreeChange(e, "agreeSalvage")} />*/}
                {/*}*/}

                {
                    this.props.umCoverageDeclined 
                        ? 
                        <ComplexCheckbox
                            children={
                                <div>
                                    <Form.Check.Label>I Agree</Form.Check.Label>
                                    <p>I decline the UM coverage</p>
                                </div>
                            }
                            value={this.state.agreeUMDecline}
                            onChange={(e) => this.handleAgreeChange(e, "agreeUMDecline")} />
                        : null
                }

                <Form.Group>
                    <label className={"chbxCust" + (this.state.agreeEmailCorrect ? " selected" : "")}>
                        <Form.Check type="checkbox">
                            <Checkbox theme="bootstrap-checkbox"
                                children={
                                    <div>
                                        <Form.Check.Label>I Agree</Form.Check.Label>
                                        <p>Email address specified correctly</p>
                                    </div>}
                                value={this.state.agreeEmailCorrect}
                                onChange={(e) => { this.handleAgreeChange(e, "agreeEmailCorrect"); this.validateContactInfo(); }}></Checkbox>
                        </Form.Check>
                        <ValidatableForm hasErrors={null != this.state.errors}>
                            <ValidatableFormGroup
                                isChild={true}
                                label=""
                                disabled={this.state.agreeEmailCorrect}
                                value={this.state.contactInfo.email}
                                placeholder={this.state.contactInfo.email}
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "email")}
                                onChange={(e) => { this.handleEmailChange(e.target.value) }} />
                        </ValidatableForm>
                    </label>
                </Form.Group>

                <div className="btnContainer">
                    <ButtonContinue
                        label="Submit Signatures"
                        className="btn-sign"
                        disabled={this.state.updatingStore ||
                            !(this.state.agreeDrivers
                                && this.state.agreeOtherDrivers
                                && this.state.agreeUMDecline
                                && this.state.agreeEmailCorrect
                                && this.state.agreePolicyEffDate)}
                        showLoading={this.state.updatingStore}
                        onClick={this.next} />
                </div>

            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    let umCoverageDeclined = false;
    let hasCompColl = false;
    let _coverages = state.externalQuote?.coverages;

    if (_coverages) {
        for (let i = 0; i < _coverages.liabilityCoverages.length; i++) {
            if ("UMBI" === _coverages.liabilityCoverages[i].code
                && _coverages.liabilityCoverages[i].isDeclined
                && !_coverages.liabilityCoverages[i].isSelected) {
                umCoverageDeclined = true;
                break;
            }
        }

        for (let i = 0; i < _coverages.vehicleCoverages.length; i++) {
            if ((_coverages.vehicleCoverages[i].coverages.some(x => x.code === "COMP" && x.isSelected)
                || _coverages.vehicleCoverages[i].coverages.some(x => x.code === "COLL" && x.isSelected))) {
                hasCompColl = true;
                break;
            }
        }
    }

    let _contactInfo: IContactInfo = state.contactInfo ?? {
        id: 0,
        emailSubscription: false,
        phoneMessagesSubscription: false,
        phone: "",
        email: ""
    };

    return {
        rtrQuoteId: state.externalQuote?.rtrQuoteId,
        umCoverageDeclined: umCoverageDeclined,
        hasCompColl: hasCompColl,
        contactInfo: _contactInfo,
        policyEffDate: state.externalQuote?.effectiveDate,
        effectiveDatetimeStamp: state.externalQuote?.effectiveDatetimeStamp,
        stateCode: state.stateCode
    };
};

let mapDispatch = (dispatch: any, ownProps: IProps) => {
    var quoteActions = new QuoteActions(ownProps.quoteApiClient);
    var fullQuoteActions = new FullQuoteActions(ownProps.lobApiClient);

    return {
        reportCurrentStep: () => dispatch(quoteActions.quoteStepChanged(FULL_QUOTE_STEPS.FINALIZE)),
        updateAppState: (update: IAppStateUpdate) => dispatch(fullQuoteActions.updateAgreement(update.rtrQuoteId, update.agreement, update.contactInfo)),
        resetAgreement: () => dispatch(fullQuoteActions.resetAgreement())
    };
};

export default connect(mapProps, mapDispatch)(Finalize);
